import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TemplateDesignElement } from '../../design-element';
import {
  ChannelUIds,
  CommunicationTemplate,
  CommunicationTemplateViewControl,
  MassNotificationTemplate,
  MessageSettings
} from 'src/app/modules/communications/store/communications';
import { TemplateDesignerService } from 'src/app/modules/communications/services/template-designer.service';

@Component({
    selector: 'topo-template-message-text-element',
    templateUrl: './message-text-control.component.html',
    styleUrls: ['./message-text-control.component.scss'],
    standalone: false
})
export class TemplateDesignMessageTextElement implements OnInit, OnDestroy, TemplateDesignElement {
  @Input() index: number;
  @Input() set messageSettings(value: MessageSettings) {
    this._messageSettings = value;
    this.loadData();
  }
  @Input() template?: CommunicationTemplate;
  @Input() control?: CommunicationTemplateViewControl;
  @Input() set culture(value: string) {
    this._culture = value;
    this.loadData();
  }
  @Input() orgLanguages: string[];
  @Input() selected: boolean;
  @Output() settingsChanged = new EventEmitter<{ uId: string; settings: any }>();

  _messageSettings: MessageSettings;
  _culture: string;
  editMode: boolean;
  useCustomText: boolean;
  messageText: string;
  showRichText: boolean;
  richTextOrPlaceHolder: string;

  constructor(private templateDesignerService: TemplateDesignerService) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  loadSettings(): void {
    this.editMode = true;
    this.loadData();
  }
  saveSettings(): boolean {
    return true;
  }
  render(): void {
    this.editMode = false;
    this.loadData();
  }

  private loadData(): void {
    if (this.template?.channelUId === ChannelUIds.TwilioChannelUId || this.template?.channelUId === ChannelUIds.HorizonSmsChannelUId || this.template?.channelUId === ChannelUIds.WhatsAppChannelUId) {
      this.messageText = this.templateDesignerService.getTranslateText(this._messageSettings?.smsNotificationMessage, this._culture);
      this.showRichText = false;
    } else {
      this.messageText = this.templateDesignerService.getTranslateText(this._messageSettings?.notificationMessage, this._culture);
      this.showRichText = true;
    }
  }

  edit(): void {}

  setRuntimeData(data: any): void {}
}
